export default __webpack_public_path__ + "static/media/girls-podcast.67d2ccc2.jpg";